import React, { useEffect, useState } from "react";
import tagManagerEvents, {
  AwarenessTagManagerEvents,
} from "../utils/GoogleTagManager";
import { useNavigate } from "react-router-dom";
import {
  clearAllCookies,
  getCookie,
  sha256Hash,
} from "../utils/CommonFunction";
import LandingResponse from "../pages/LandingResponse";
import "../styles/landingpage.css";

const JazzCash = () => {
  const navigate = useNavigate();
  const [landingData, setLandingData] = useState<{
    jc: "0" | "1";
    utmSource: string;
  } | null>(null);
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  let jc = searchParams.get("jc") ? searchParams.get("jc") : "0";

  useEffect(() => {
    setTimeout(() => {
      getUtmSource();
    }, 1500);
  }, []);

  const getUtmSource = () => {
    const data = getCookie("data");
    // console.log("data::", data);
    // if (data !== null) {
    //   const utmSource = data.utm_source;
    //   if (utmSource) {

    //   }
    // }

    if (jc === "1") {
      if (data?.utm_source) {
        const phone_number = sha256Hash("+92" + data?.msisdn);
        const external_id = sha256Hash("tm-" + data?.msisdn);

        let eventName: string = "";
        if (data?.mfs) {
          eventName = "Jc_Subscription_Mfs";
        } else {
          eventName = "Subscription_landing";
        }

        let _data = {
          event: eventName,
          utm_source: data?.utm_source,
          phone_number: phone_number,
          external_id: external_id,
        };

        AwarenessTagManagerEvents(_data);
        // tagManagerEvents("Subscription_landing", data?.utm_source);
      }
      clearAllCookies();
      setTimeout(() => {
        setLandingData({
          jc: "1",
          utmSource: data ? data.utm_source : "",
        });
      }, 1000);
    } else {
      console.log(data?.utm_source);
      if (data?.utm_source) {
        tagManagerEvents("JazzCashSub_Fail", data?.utm_source);
      }
      clearAllCookies();
      setTimeout(() => {
        setLandingData({
          jc: "0",
          utmSource: data ? data.utm_source : "",
        });
      }, 1000);
    }
  };

  if (landingData) {
    return (
      <LandingResponse jc={landingData.jc} utmSource={landingData.utmSource} />
    );
  }

  return (
    <div className="dm-section landing-loading">
      <div className="main-content">
        <div className="landing-loading-wrap">
          <div className="landing-loader" />
        </div>
      </div>
    </div>
  );
};

export default JazzCash;
